export const useParserHtml = (content: string) => {
  if(typeof window === 'undefined') return { html: content }
	const node = document.createElement('div')
	node.innerHTML = content
	const dom = new DOMParser().parseFromString('<!doctype html><body>' + node.textContent, 'text/html')
	let html = dom.body.innerHTML
	return { html }
}
